const locales = {
  ar: {
    code: 'ar',
    lang: 'ar',
    dir: 'rtl',
    pathPrefix: '/ar',
  },
  en: {
    code: 'en',
    lang: 'en',
    dir: 'ltr',
    pathPrefix: '/en',
  },
};

const localeCodes = Object.keys(locales);
const defaultLocale = 'ar';
const legacyLocale = 'en';
const storageKey = 'portfolio-locale';

const isSupportedLocale = locale => localeCodes.includes(locale);

const getLocale = locale => locales[isSupportedLocale(locale) ? locale : defaultLocale];

module.exports = {
  defaultLocale,
  getLocale,
  isSupportedLocale,
  legacyLocale,
  localeCodes,
  locales,
  storageKey,
};
